"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PACKAGE_TONE_OPTIONS = exports.PACKAGE_TONES = void 0;
exports.isValidPackageAccent = isValidPackageAccent;
exports.normalizePackageTheme = normalizePackageTheme;
exports.normalizePackageTone = normalizePackageTone;
/** Όλες οι διαθέσιμες παλέτες εμφάνισης πακέτου (Admin + UI). */
exports.PACKAGE_TONES = [
    'violet',
    'bronze',
    'silver',
    'gold',
    'sky',
    'emerald',
    'rose',
    'indigo',
    'teal',
    'amber',
    'cyan',
    'fuchsia',
];
exports.PACKAGE_TONE_OPTIONS = [
    { value: 'violet', label: 'Violet (Basic)' },
    { value: 'bronze', label: 'Bronze — παλιό (≈ Pro)' },
    { value: 'silver', label: 'Silver — παλιό (≈ Pro)' },
    { value: 'gold', label: 'Gold — παλιό (≈ Business)' },
    { value: 'sky', label: 'Sky (γαλάζιο)' },
    { value: 'emerald', label: 'Emerald (πράσινο)' },
    { value: 'rose', label: 'Rose (ροζ)' },
    { value: 'indigo', label: 'Indigo (βαθύ μπλε)' },
    { value: 'teal', label: 'Teal (πετρόλ)' },
    { value: 'amber', label: 'Amber (κεχριμπαρί)' },
    { value: 'cyan', label: 'Cyan (κυανό)' },
    { value: 'fuchsia', label: 'Fuchsia (φούξια)' },
];
const HEX_COLOR = /^#[0-9A-Fa-f]{6}$/;
function isValidPackageAccent(value) {
    return Boolean((value === null || value === void 0 ? void 0 : value.trim()) && HEX_COLOR.test(value.trim()));
}
function normalizePackageTheme(raw) {
    if (!raw || typeof raw !== 'object')
        return null;
    const row = raw;
    const accent = typeof row.accent === 'string' && isValidPackageAccent(row.accent)
        ? row.accent
        : undefined;
    const accentDark = typeof row.accentDark === 'string' && isValidPackageAccent(row.accentDark)
        ? row.accentDark
        : undefined;
    if (!accent && !accentDark)
        return null;
    return { accent, accentDark: accentDark !== null && accentDark !== void 0 ? accentDark : accent };
}
function normalizePackageTone(tone) {
    return exports.PACKAGE_TONES.includes(tone)
        ? tone
        : 'violet';
}
